export default __webpack_public_path__ + "static/media/aweber.e95169a3.svg";